import { Dispatch, SetStateAction, useEffect } from "react";
import { SimpleErrorNotification, SimpleLoader } from "shared/components";
import { useNotesContext } from "shared/contextProviders";
import { SegmentedNotesView } from "./SegmentedNotesView";
import { GridNotesView } from "./GridNotesView";
import { TimelineNotesView } from "./TimelineNotesView";

export type NotesContentProps = {
  // "grid" = notes on a page; "segmented" = side panel with Open/Archived carousel; "timeline" = grouped by date like People slideout
  viewType?: "grid" | "segmented" | "timeline";
  forceSingleColumn?: boolean;
  isCreatingNote: boolean;
  setIsCreatingNote: Dispatch<SetStateAction<boolean>>;
  setNoteCount?: Dispatch<SetStateAction<number>>;
  suggestionsPortalHost?: HTMLElement | null;
};

export const NotesContent = ({
  viewType = "grid",
  forceSingleColumn,
  setNoteCount,
  isCreatingNote,
  setIsCreatingNote,
  suggestionsPortalHost,
}: NotesContentProps) => {
  const { initialLoad, error, notes } = useNotesContext();

  useEffect(() => setNoteCount?.(notes.length ?? 0), [notes, setNoteCount]);

  if (initialLoad) return <SimpleLoader />;

  if (error) return <SimpleErrorNotification />;

  if (viewType === "timeline") {
    return (
      <TimelineNotesView
        isCreatingNote={isCreatingNote}
        setIsCreatingNote={setIsCreatingNote}
        suggestionsPortalHost={suggestionsPortalHost}
      />
    );
  }

  return viewType === "grid" ? (
    <GridNotesView
      isCreatingNote={isCreatingNote}
      setIsCreatingNote={setIsCreatingNote}
      forceSingleColumn={forceSingleColumn}
    />
  ) : (
    <SegmentedNotesView
      isCreatingNote={isCreatingNote}
      setIsCreatingNote={setIsCreatingNote}
    />
  );
};
